import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Remove the pre-React splash once the app has mounted AND React has had
// time to paint at least one frame of real UI. Two-rAF pattern guarantees
// the browser has committed paint before we fade. Without this, Instagram's
// in-app browser shows a brief white blink between splash and React mount.
const removeSplash = () => {
  const splash = document.getElementById("pre-react-splash");
  if (!splash) return;
  splash.classList.add("is-hidden");
  setTimeout(() => splash.remove(), 450);
};
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    // Tiny grace period (60ms) so React's first paint completes before fade.
    setTimeout(removeSplash, 60);
  });
});
// If the page is restored from the bfcache (back/forward in Instagram in-app
// browser), the splash may still be in the DOM but we have to ensure it's gone.
window.addEventListener("pageshow", (e) => {
  if (e.persisted) removeSplash();
});
